(function () {
  if (window.matchMedia('(max-width: 989px)').matches) return;

  var nav = document.getElementById('rm-nav-hb');
  var items = document.querySelectorAll('.rm-nav__item--has-mega');
  var headerWrapper = document.querySelector('.header-wrapper');
  var closeTimer;

  function closeAll() {
    items.forEach(function (item) {
      item.classList.remove('is-open');
    });
    document.body.classList.remove('rm-mega-open');
  }

  function openItem(item) {
    closeAll();
    item.classList.add('is-open');
    document.body.classList.add('rm-mega-open');
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('.rm-nav__trigger');
    if (!trigger) return;

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openItem(item);
    });

    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
        if (!document.querySelector('.rm-nav__item.is-open')) {
          document.body.classList.remove('rm-mega-open');
        }
      }, 150);
    });

    trigger.addEventListener('focus', function () {
      openItem(item);
    });
  });

  if (headerWrapper) {
    headerWrapper.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(closeAll, 180);
    });
    headerWrapper.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
